export const COLUNAS_TEXTO_TRUNCADO = 'ColunasTextoTruncado';

export function valorEstaTruncado(row, coluna) {
  const fonteDados = coluna?.FonteDados;
  const colunas = row?.[COLUNAS_TEXTO_TRUNCADO];
  if (!fonteDados || !Array.isArray(colunas)) return false;

  return colunas.includes(fonteDados);
}

export function obterFonteDadosChaveUnica(visaoColunas = []) {
  return (visaoColunas || []).find(coluna => coluna?.ChaveUnicaModulo)
    ?.FonteDados;
}

export function obterValorChaveRegistro(row, visaoColunas) {
  const fonteDados = obterFonteDadosChaveUnica(visaoColunas);
  if (!fonteDados || !row) return '';

  const valor = row[fonteDados];
  if (valor === null || valor === undefined || valor === '') return '';

  return String(valor);
}

const NOMES_MES = [
  '',
  'JANEIRO',
  'FEVEREIRO',
  'MARCO',
  'ABRIL',
  'MAIO',
  'JUNHO',
  'JULHO',
  'AGOSTO',
  'SETEMBRO',
  'OUTUBRO',
  'NOVEMBRO',
  'DEZEMBRO',
];

function obterNomePeriodo(mes) {
  if (mes === null || mes === undefined || mes === '') return null;
  if (typeof mes === 'string' && Number.isNaN(Number(mes))) return mes;

  return NOMES_MES[Number(mes)] || null;
}

export function montarPayloadTextoColuna({
  chaveModulo,
  nomeVisao,
  fonteDados,
  valorChave,
  row,
  exercicio,
  periodicidade,
  periodo,
}) {
  const payload = {
    ChaveModulo: chaveModulo,
    NomeVisao: nomeVisao,
    FonteDados: fonteDados,
    ValorChave: valorChave,
  };

  const exercicioFinal = exercicio ?? row?.Exercicio;
  const periodoFinal = periodo || obterNomePeriodo(row?.Mes);
  const periodicidadeFinal =
    periodicidade || (periodoFinal ? 'MENSAL' : null);

  if (exercicioFinal !== null && exercicioFinal !== undefined && exercicioFinal !== '') {
    payload.Exercicio = Number(exercicioFinal);
  }
  if (periodicidadeFinal) payload.Periodicidade = periodicidadeFinal;
  if (periodoFinal) payload.Periodo = periodoFinal;

  return payload;
}
